import { render } from "./UserAccountSettings.vue?vue&type=template&id=29d83078&scoped=true"
import script from "./UserAccountSettings.vue?vue&type=script&lang=js"
export * from "./UserAccountSettings.vue?vue&type=script&lang=js"

import "./UserAccountSettings.styles.css?vue&type=style&index=0&id=29d83078&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d83078"]])

export default __exports__